export const POST_INSTAGRAM_CODE = 'POST_INSTAGRAM_CODE';
export const POST_INSTAGRAM_USER_TOKEN = 'POST_INSTAGRAM_USER_TOKEN';
